import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import moment from "moment";
import { BlobSaver } from "src/app/miscellaneous/file-downloader";
import { environment } from "src/environments/environment";

@Injectable({ providedIn: 'root' })
export class CommandGetCarcase {
    constructor(
        private readonly http: HttpClient,
    ) {}

    public async Retrieve(
        fileId: string,
        advice: number,
        season: number,
        propertyId: number,
        killDate: Date,
    ): Promise<void> {
        const res = await this.RequestCarcaseFile(fileId);
        const date = moment(killDate).format("YYYYMMDD");
        BlobSaver.saveFile(
            res,
            "FB-" + season + "-" + advice + "-" + propertyId + "-" + date + ".pdf"
          );
    }

    private async RequestCarcaseFile(fileId: string): Promise<Blob> {
        const params: any = { fileId };
        const pdfBlob = await this.http
            .get(
                environment.apiUrl + "/api/documents/feedback-file",
                {
                    responseType: "blob",
                    params,
                })
            .toPromise();

        return pdfBlob as Blob;
    }
}